import api from '@/api'
import { omit } from '@/helper'
import notifier from '@/notifier'

const findByIdentifierAndType = (data, type, identifier) => data.find(definitionModule =>
  definitionModule.identifier === identifier && definitionModule.type === type)

export default {
  namespaced: true,
  state: {
    definitionModules: []
  },
  actions: {
    async fetch ({ commit }) {
      commit('setDefinitionModules', await api.getDefinitionModules())
    },
    async fetchModuleConfiguration ({ state, getters, commit }, { type, identifier }) {
      const definitionModule = getters.getDefinitionModuleByIdentifierAndType(type, identifier)
      definitionModule.module.configs = await api.getConfiguration(type, identifier)
      definitionModule.module.configsLoaded = true
      commit('setDefinitionModule', definitionModule)
    },
    async install ({ getters }, { type, identifier }) {
      const definitionModule = getters.getDefinitionModuleByIdentifierAndType(type, identifier)
      definitionModule.module = await api.installModule(type, identifier)
    },
    async saveConfiguration ({ commit, getters }, { type, identifier, configuration }) {
      const definitionModule = getters.getDefinitionModuleByIdentifierAndType(type, identifier)
      definitionModule.module.configs = await api.saveConfiguration(type, identifier, omit(configuration))
      commit('setDefinitionModule', definitionModule)
    },
    async active ({ getters }, { type, identifier }) {
      const definitionModule = getters.getDefinitionModuleByIdentifierAndType(type, identifier)
      await api.activeModule(type, identifier)
      definitionModule.module.status = true
    },
    async inactive ({ getters }, { type, identifier }) {
      const definitionModule = getters.getDefinitionModuleByIdentifierAndType(type, identifier)
      await api.inactiveModule(type, identifier)
      definitionModule.module.status = false
    },
    async checkAuth ({ getters }, { type, identifier }) {
      return await api.checkApiStatus(type, identifier)
    }
  },
  getters: {
    getDefinitionModuleByIdentifierAndType: (state) => (type, identifier) =>
      findByIdentifierAndType(state.definitionModules, type, identifier),
    modules: state => state.definitionModules
      .filter(definitionModule => definitionModule.module)
      .map(definitionModule => definitionModule.module),
    definitionEcommerceInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type === 'ecommerce'),
    definitionErpInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type === 'erp'),
    definitionMarketplacesInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type === 'marketplace'),
    definitionToolsInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type === 'tool'),
    definitionShipmentsInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type === 'shipment'),
    definitionModulesInstalled: state => state.definitionModules
      .filter(definitionModule => definitionModule.module),
    definitionModulesInstalledWithoutTypeTool: state => state.definitionModules
      .filter(definitionModule => definitionModule.module && definitionModule.module.type !== 'tool')
  },
  mutations: {
    setDefinitionModules (state, definitionModules) {
      definitionModules.forEach(item => {
        if (item.warning) {
          notifier.error(item.warning.message, item.name)
          item.module.status = false
        }
      })

      state.definitionModules = [...definitionModules]
    },
    setDefinitionModule (state, definitionModule) {
      const index = state.definitionModules.indexOf(definitionModule)
      if (index >= 0) {
        state.definitionModules[index] = {...definitionModule}
      }
      state.definitionModules = [...state.definitionModules]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/module.js